export const getTagPrefix = (tagId: string): string => tagId.substring(0, tagId.indexOf('/'));
export const getTagSuffix = (tagId: string): string => tagId.substring(tagId.indexOf('/') + 1, tagId.length);
